/**
 * TEMPORARY, dev only: which pose source a tester forced from the scan screen's
 * pose source pill (`src/Components/DevPoseSourcePill`). Delete this module
 * with the pill once internal testing of the dev build is over.
 *
 * `auto` is the real routing — `poseSourceRouter` and `PoseSourceController`
 * decide. `device` and `server` bypass both: what the tester picked is what
 * runs, and a failure shows on the pill instead of being quietly rescued.
 *
 * Remembered per phone in `localStorage`. A prod build always reads `auto`
 * and cannot be set, whatever is stored, so the switch cannot leak into real
 * sessions even if a prod bundle somehow shipped it. Storage failures are
 * swallowed and the choice lives in memory for the page load: it is a test
 * convenience, not a contract (see HERE_BE_DRAGONS.md § "Three near-identical
 * safe-storage marker modules" — this is deliberately not one of them).
 */

export type PoseSourceOverride = "auto" | "device" | "server";

const KEY = "ttf:dev:poseSourceOverride";

const isProdBuild = () => process.env.REACT_APP_IS_PROD_ENV === "true";

function readStored(): PoseSourceOverride {
  try {
    const raw = localStorage.getItem(KEY);
    return raw === "device" || raw === "server" ? raw : "auto";
  } catch {
    return "auto";
  }
}

let current: PoseSourceOverride = isProdBuild() ? "auto" : readStored();

export function getPoseSourceOverride(): PoseSourceOverride {
  return current;
}

export function setPoseSourceOverride(mode: PoseSourceOverride): void {
  if (isProdBuild()) return;
  current = mode;
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* in memory for this page load */
  }
}
